import React from 'react';

import type { PatientIntakeStep } from '@shared/patient-intake-status';

import { BaseStepViewer } from './BaseStepViewer';
import { CustomStepViewer } from './CustomStepViewer';

type StepApprovalSectionProps = {
  step: PatientIntakeStep;
};

export const StepApprovalSection: React.FC<StepApprovalSectionProps> = ({ step }) => {
  if (step.stepType === 'BASE_STEP') {
    return <BaseStepViewer baseField={step.id} step={step} />;
  }

  return <CustomStepViewer healthCategoryId={step.healthCategoryId} step={step} />;
};
